<template>
  <div class="not-found-page">
    <div>
      <div class="not-found-title">404</div>
      <div class="not-found-name">{{$t('notFound')}}</div>
<!--      <div class="not-found-en">Please check your network data or restart refresh browser to try.</div>-->
      <button class="not-found-btn" @click="$router.push('/index')">{{$t('goToIndex')}}</button>
    </div>
    <div>
      <img class="not-found-img" src="../../public/static/notFound.png">
    </div>
  </div>
</template>

<script>
  export default {
    name: 'notFound',
  }
</script>

<style lang="scss">
.not-found-page{
  background-color: #FAFAFB;
  border-radius: 10px;
  padding: 100px 120px;
  display: flex;
  justify-content: space-between;
  .not-found-title{
    color: #1F6CBA;
    font-size: 80px;
    font-weight: 800;
  }
  .not-found-name{
    color: #333333;
    font-size: 24px;
    font-weight: 500;
    margin-top: 10px;
  }
  .not-found-en{
    color: #999999;
    font-size: 20px;
    font-weight: 500;
    margin-top: 18px;
  }
  .not-found-btn{
    padding: 12px 30px;
    background-color: #1F6CBA;
    border: none;
    border-radius: 4px;
    color: #FFFFFF;
    font-size: 20px;
    margin-top: 40px;

  }
  .not-found-img{
    width: 500px;
  }
}
</style>
